import React from 'react';
import { toast } from 'sonner';
import { FiAlertCircle, FiAlertTriangle, FiCheckCircle, FiInfo } from 'react-icons/fi';

type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastOptions {
  description?: string;
  duration?: number;
}

const SuccessIcon = FiCheckCircle as unknown as React.ComponentType<{ size?: number; color?: string }>;
const ErrorIcon = FiAlertCircle as unknown as React.ComponentType<{ size?: number; color?: string }>;
const WarningIcon = FiAlertTriangle as unknown as React.ComponentType<{ size?: number; color?: string }>;
const InfoIcon = FiInfo as unknown as React.ComponentType<{ size?: number; color?: string }>;

const toastPalette: Record<ToastType, { background: string; border: string; color: string }> = {
  success: { background: '#ecfdf3', border: '#a6f4c5', color: '#027a48' },
  error: { background: '#fef3f2', border: '#fecdca', color: '#b42318' },
  warning: { background: '#fffaeb', border: '#fedf89', color: '#b54708' },
  info: { background: '#eff8ff', border: '#b2ddff', color: '#175cd3' },
};

const toastIcon: Record<ToastType, React.ReactNode> = {
  success: <SuccessIcon size={18} color={toastPalette.success.color} />,
  error: <ErrorIcon size={18} color={toastPalette.error.color} />,
  warning: <WarningIcon size={18} color={toastPalette.warning.color} />,
  info: <InfoIcon size={18} color={toastPalette.info.color} />,
};

export const showToast = (type: ToastType, message: string, options?: ToastOptions): void => {
  const style = {
    background: toastPalette[type].background,
    border: `1px solid ${toastPalette[type].border}`,
    color: toastPalette[type].color,
    width: 'min(92vw, 460px)',
    fontWeight: 600,
  };

  const commonOptions = {
    description: options?.description,
    duration: options?.duration ?? 3000,
    icon: toastIcon[type],
    style,
  };

  if (type === 'success') {
    toast.success(message, commonOptions);
    return;
  }

  if (type === 'error') {
    toast.error(message, commonOptions);
    return;
  }

  if (type === 'warning') {
    toast.warning(message, commonOptions);
    return;
  }

  toast.info(message, commonOptions);
};
